export var SCROLL_INCREMENT = 3;
export var HOVER_DELAY = 200;
export var SCROLL_BUFFER = 30;
export var CATEGORY_MENU_DESKTOP_WIDTH = 200;
export var POPOVER_ZINDEX = 101;